import * as React from "react";
import { Box, Typography, Divider } from "@mui/material";
import { useNavigate } from "react-router-dom";
import "./Footer.css";

export default function Footer() {
  const navigate = useNavigate();

  return (
    <Box component="footer" className="app-footer">
      <Divider className="app-footer-divider" />
      <Box className="app-footer-content">
        <Typography variant="body2" color="text.secondary">
          Created & Designed by Hadley Swello (2017–{new Date().getFullYear()})
        </Typography>
        <Typography variant="caption" className="app-footer-links">
          <Typography
            component="span"
            variant="caption"
            onClick={() => navigate("/privacy")}
            className="app-footer-link"
          >
            Privacy
          </Typography>{" "}
          ·{" "}
          <Typography
            component="span"
            variant="caption"
            onClick={() => navigate("/terms")}
            className="app-footer-link"
          >
            Terms
          </Typography>
        </Typography>
      </Box>
    </Box>
  );
}

